import {
    cardTitle
} from "assets/jss/material-dashboard-pro-react.js";
import {
    dangerColor,
    whiteColor,
    secondaryColor
  } from "@themes/defaultThemeProps";
  
import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.js";
  
  const clientEditStyle = {
    ...hoverCardStyle,
// from validation form style
    ...customCheckboxRadioSwitch,
    cardTitle: {
      ...cardTitle,
      color: whiteColor
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
    },
    formCategory: {
      marginBottom: "0",
      color: secondaryColor[0],
      fontSize: "14px",
      padding: "10px 0 10px"
    },
    center: {
      textAlign: "center"
    },
    justifyContentCenter: {
      justifyContent: "center"
    },
    registerButton: {
      float: "right"
    },
    leftButton: {
        float: "left"
    },
    danger: {
      color: dangerColor[0] + "!important"
    },
// from extended table style
    ...buttonGroupStyle,
    right: {
      textAlign: "right"
    },
    description: {
      maxWidth: "150px"
    },
    actionButton: {
      margin: "0 0 0 5px",
      padding: "5px",
      "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
        marginRight: "0px"
      }
    },
    icon: {
      verticalAlign: "middle",
      width: "17px",
      height: "17px",
      top: "-1px",
      position: "relative"
    },
    imgContainer: {
      width: "120px",
      maxHeight: "160px",
      overflow: "hidden",
      display: "block"
    },
    img: {
      width: "100%",
      height: "auto",
      verticalAlign: "middle",
      border: "0"
    },
    tdName: {
      minWidth: "200px",
      fontWeight: "400",
      fontSize: "1.5em"
    },
    tdNameAnchor: {
      color: secondaryColor[2]
    },
    tdNameSmall: {
      color: secondaryColor[0],
      fontSize: "0.75em",
      fontWeight: "300"
    },
    tdNumber: {
      textAlign: "right",
      minWidth: "145px",
      fontWeight: "300",
      fontSize: "1.3em !important"
    },
    tdNumberSmall: {
      marginRight: "3px"
    },
    tdNumberAndButtonGroup: {
      lineHeight: "1 !important"
    },
    positionAbsolute: {
      position: "absolute",
      right: "0",
      top: "0"
    },
    customFont: {
      fontSize: "16px !important"
    },
    actionButtonRound: {
      width: "auto",
      height: "auto",
      minWidth: "auto"
    },
    editor: {
        fontFamily: "sans-serif",
        maxWidth: "33rem",
        margin: "1rem auto",
        padding: "0.5rem",
        border: "1px solid #999"
    }
  };
  
  export default clientEditStyle;
  